import { render, staticRenderFns } from "./RegiaoManage.vue?vue&type=template&id=38629dfd&scoped=true"
import script from "./RegiaoManage.vue?vue&type=script&lang=js"
export * from "./RegiaoManage.vue?vue&type=script&lang=js"
import style0 from "./RegiaoManage.vue?vue&type=style&index=0&id=38629dfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38629dfd",
  null
  
)

export default component.exports